export default "__VITE_ASSET__BYlMLlU$__"